module.exports = __webpack_public_path__ + "static/media/FooterLogo.6c948990.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FooterLogo.png
// module id = 58
// module chunks = 1